import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Badge, Panel } from '@usacow/ds';
import { api, type ChecklistItem } from '../../lib/api';

type Data = Awaited<ReturnType<typeof api.adminScenario>>;

export function ScenarioDetail() {
  const { id = '', version = '' } = useParams();
  const [data, setData] = useState<Data | null>(null);

  useEffect(() => {
    api
      .adminScenario(id, version)
      .then(setData)
      .catch(() => setData(null));
  }, [id, version]);

  if (!data) return <div className="dim">Loading…</div>;
  const allPass = data.checklist.every((c: ChecklistItem) => c.pass);

  return (
    <div className="scr scr--narrow">
      <Link to="/admin" className="lib-back">
        ← Inventory
      </Link>
      <div className="scr-head">
        <div>
          <div className="t-eyebrow">scenario · v{version}</div>
          <h1 className="scr-h">{id}</h1>
        </div>
        <Badge tone={allPass ? 'correct' : 'incorrect'}>
          {allPass ? 'publishable' : 'blocked'}
        </Badge>
      </div>

      <Panel title="Publishing checklist" meta="live from the validator">
        <div className="adm-checklist">
          {data.checklist.map((c: ChecklistItem) => (
            <div className="adm-check" key={c.gate}>
              <span className={`adm-check__dot${c.pass ? ' ok' : ' bad'}`}>
                {c.pass ? '✓' : '✕'}
              </span>
              <span className="adm-check__g">{c.gate}</span>
              <span className="adm-check__d dim mono">{c.detail}</span>
            </div>
          ))}
        </div>
      </Panel>

      {!data.validation.ok && (
        <Panel title="Validator errors" style={{ marginTop: 12 }}>
          <ul className="lib-list lib-list--bad">
            {data.validation.errors.map((e, i) => (
              <li key={i}>
                <span className="mono">{e.path}</span> — {e.code}
              </li>
            ))}
          </ul>
        </Panel>
      )}
    </div>
  );
}
